module.exports = __webpack_public_path__ + "img/Dantam Hair 01.385f88f7.jpg";